import AppDataContext from 'context/AppDataContext';
import React, { useContext } from 'react'
import MapBox from '../../../../components/MapBox/MapBox';
import { GeoRiskData } from '../../../Scan/data/MapData';
import styles from './MostAffectedRegionsWidget.module.scss';

export default function MostAffectedRegionsWidget() {

  const { setNavText } = useContext(AppDataContext);


  return (
    <div className="widget" style={{ height: "30rem" }}>
      {/* header */}
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="widget-title">Most Affected Regions</h3>

        <button
          className="btn btn-flat text-white flex-center"
          onClick={() => setNavText("view-regions")}
        >
          View Report
          <i className="icon-arrow-right text-5c ml-2"></i>
        </button>
      </div>
      {/* Header */}

      <h6 className="text-gray-400 fw-300">
        <small className="text-gray-500 ml-1">Description</small>
      </h6>

      <div className={styles.widgetBody}>
        <div className="mb-4">
          <h4 className="fw-300">
            Europe
            <span className="d-inline-flex ml-3">8,739</span>
          </h4>
          <span className="dot bg-danger mr-2"></span>
          <small className="text-gray-400">High increasing</small>
        </div>

        <div className="mb-4">
          <h4 className="fw-300">
            North America
            <span className="d-inline-flex ml-3">2,994</span>
          </h4>
          <span className="dot bg-indigo-600 mr-2"></span>
          <small className="text-gray-400">Medium increasing</small>
        </div>

        <div className="mb-4">
          <h4 className="fw-300">
            Asia
            <span className="d-inline-flex ml-3">1,234</span>
          </h4>
          <span className="dot bg-indigo-400 mr-2"></span>
          <small className="text-gray-400">Medium stable</small>
        </div>
      </div>

      {/* Map */}
      <div className={styles.widgetMap}>
        <div className={styles.widgetMapHolder}>
          <MapBox
            mapHeight="20rem"
            zoom={2.65}
            showControl={false}
            riskMarkers={GeoRiskData}
          />
        </div>
      </div>
    </div>
  );
}
